/**
 * Filtro de intervalo de datas reutilizável (Usuários, Estatísticas, Vendas).
 * Lógica pura. `from`/`to` são strings YYYY-MM-DD (ou vazio = sem limite).
 * O limite superior é inclusivo até o fim do dia.
 */

/** Converte 'YYYY-MM-DD' em Date local no início do dia, ou null. */
export function parseStartOfDay(str) {
  if (!str || !/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
  const [y, m, d] = str.split('-').map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

/** Converte 'YYYY-MM-DD' em Date local no fim do dia, ou null. */
export function parseEndOfDay(str) {
  if (!str || !/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
  const [y, m, d] = str.split('-').map(Number);
  return new Date(y, m - 1, d, 23, 59, 59, 999);
}

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === 'function') return value.toDate();
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** True se `value` (Date/Timestamp/string) está dentro de [from, to]. */
export function isWithinRange(value, from, to) {
  const start = parseStartOfDay(from);
  const end = parseEndOfDay(to);
  if (!start && !end) return true;
  const d = toDate(value);
  if (!d) return false;
  if (start && d < start) return false;
  if (end && d > end) return false;
  return true;
}

/**
 * Filtra uma lista por um campo de data.
 * @param {Array} items
 * @param {(item:any)=>any} getDate extrai a data do item
 * @param {string} from
 * @param {string} to
 */
export function filterByDateRange(items, getDate, from, to) {
  if (!Array.isArray(items)) return [];
  if (!from && !to) return items.slice();
  return items.filter((item) => isWithinRange(getDate(item), from, to));
}
